import { config } from '@endaoment-frontend/config';

/** The public impact dashboard — apps/overview, served from impact.endaoment.org. */
export const home = () => config.baseUrls.overview;
